import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetActiveVoucherResponse, PostWavesRequest, GetActiveVoucherRequest } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'waves.component.html',
  styleUrls: ['./waves.component.scss']
})
export class WavesComponent implements OnInit {
  vouchersResponse: GetActiveVoucherResponse | null = null;
  choosedWave: number | null = null;
  inputWaveCount: number | null = null;
  inputWaveText: string = '';
  pageTitle: string = 'Waves';
  loading: boolean = true;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.refreshActiveVoucher();
  }

  async refreshActiveVoucher() {
    this.loading = true;
    const request: GetActiveVoucherRequest = {};
    try {
      const response = await this.courierService.getActiveVouchers(request).toPromise();
      this.vouchersResponse = response ?? null;
      if (response && response.voucher) {
        this.activeUserLocalDataService.setActiveCourierVoucher(response.voucher);
      } else {
        this.activeUserLocalDataService.setActiveCourierVoucher(null);
      }
    } catch (error) {
      console.error('Error fetching active voucher:', error);
    } finally {
      this.loading = false;
    }
  }

  chooseWave(wave: number) {
    this.choosedWave = wave;
    this.pageTitle = this.translate.instant(`Wave${wave}`);
    const voucher = this.vouchersResponse?.voucher;
    if (voucher) {
      switch (wave) {
        case 1:
          this.inputWaveCount = voucher.wave0Count ?? null;
          this.inputWaveText = voucher.wave0Text;
          break;
        case 2:
          this.inputWaveCount = voucher.wave1Count ?? null;
          this.inputWaveText = voucher.wave1Text;
          break;
        case 3:
          this.inputWaveCount = voucher.wave2Count ?? null;
          this.inputWaveText = voucher.wave2Text;
          break;
        case 4:
          this.inputWaveCount = voucher.wave3Count ?? null;
          this.inputWaveText = voucher.wave3Text;
          break;
        case 5:
          this.inputWaveCount = voucher.wave4Count ?? null;
          this.inputWaveText = voucher.wave4Text;
          break;
      }
    }
  }

  onFieldDataChanged(e: any) {
    if (e.dataField === 'inputWaveCount') {
      this.inputWaveCount = e.value;
    } else if (e.dataField === 'inputWaveText') {
      this.inputWaveText = e.value;
    }
  }

  async saveWave() {
    this.loading = true;
    if (this.choosedWave !== null && this.vouchersResponse?.voucher) {
      const request: PostWavesRequest = {
        voucherId: this.vouchersResponse.voucher.id,
        waveNumber: this.choosedWave,
        waveCount: this.inputWaveCount ?? undefined,
        waveText: this.inputWaveText
      };
      try {
        await this.courierService.postWaves(request).toPromise();
        this.router.navigate(['/voucher']);
      } catch (error) {
        console.error('Error posting wave data:', error);
      }
    }
    this.loading = false;
  }

  backToVoucher() {
    this.router.navigate(['/voucher']);
  }

  backToWaves() {
    this.choosedWave = null;
    this.pageTitle = this.translate.instant('Waves');
  }
}